export const SAVE_CONSIGNEE = "account/consignee/";
export const GET_CONSIGNEES = "account/consignee/";
export const SAVE_EXPORT_JOB = "account/exportJobs/";
export const GET_EXPORT_JOBS = "account/exportJobs/timeperiod/";
export const EDIT_EXPORT_JOB = "account/exportJobs/show/";
export const DELETE_EXPORT_JOB = "account/exportJobs/delete/";
export const GENERATE_CHECKLIST = "account/exportJobs/checklist/";
export const GENERATE_FLATFILE = "account/exportJobs/flatfile/";
